import SubscriptionPlanCard from './SubscriptionPlanCard';

const SubscriptionPricingGrid = ({
  plans,
  billingInterval,
  subscription,
  isPaidActive,
  currentPlanSlug,
  currentInterval,
  daysRemaining,
  slugRanks,
  currentPlanRank,
  subscribing,
  handleSubscribe,
  handleUpgradeClick,
  handleDirectDowngradeRequest,
  handleEnterpriseRequest,
  formatPrice,
  navigate
}) => {
  return (
    <section className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 mb-8">
      {plans.map((plan) => (
        <SubscriptionPlanCard
          key={plan._id}
          plan={plan}
          billingInterval={billingInterval}
          subscription={subscription}
          isPaidActive={isPaidActive}
          currentPlanSlug={currentPlanSlug}
          currentInterval={currentInterval}
          daysRemaining={daysRemaining}
          slugRanks={slugRanks}
          currentPlanRank={currentPlanRank}
          subscribing={subscribing}
          handleSubscribe={handleSubscribe}
          handleUpgradeClick={handleUpgradeClick}
          handleDirectDowngradeRequest={handleDirectDowngradeRequest}
          handleEnterpriseRequest={handleEnterpriseRequest}
          formatPrice={formatPrice}
          navigate={navigate}
        />
      ))}
    </section>
  );
};

export default SubscriptionPricingGrid;
